import PrivateLayout from 'src/components/templates/private/private.component';
import routerFactory, { IRoute } from 'src/libraries/router.library';
import Error404 from 'src/components/pages/error/error-404/error-404.component';
import FlightDispatchList from 'src/components/pages/fire-dispatch/fire-dispatch-list/fire-dispatch-list.component';
import Error403 from 'src/components/pages/error/error-403/error-403.component';
import AdminMenu from './components/pages/admin/admin-menu.component';
import Notification from './components/pages/notification/notification.component';
import Lang from './libraries/language';
import FlightRequestList from './components/pages/flight/flight-request-list/flight-request-list.component';
import FlightRequestAdd from './components/pages/flight/flight-request-add/flight-request-add.component';
import FlightRequestEdit from './components/pages/flight/flight-request-edit/flight-request-edit.component';
import { AccessType } from './constants';
import FlightRequestAssessment from './components/pages/flight/flight-request-assessment/flight-assessment.component';
import FlightRequestDuplicate from './components/pages/flight/flight-request-duplicate/flight-request-duplicate.component';
import FireDispatchAdd from './components/pages/fire-dispatch/fire-dispatch-add/fire-dispatch-add.component';
import FireDispatchEdit from './components/pages/fire-dispatch/fire-dispatch-edit/fire-dispatch-edit.component';
import FlightsCalendar from './components/pages/flights-calendar/flights-calendar.component';

/**
 * This will centralized all the routes for this application,
 * which makes them easier to access and maintain.
 * This will also avoid route duplications.
 */
const Main: IRoute = {
  path: '/',
  layout: PrivateLayout,
  to: '/flight',
};

const FlightsCalendarRoute: IRoute = {
  label: Lang.TTL_FLIGHTS_CALENDAR,
  path: '/flightsCalendar',
  layout: PrivateLayout,
  component: FlightsCalendar,
  permission: AccessType.ADMIN_READ,
};

const FlightRequest: IRoute = {
  label: Lang.TTL_FLIGHT_REQUEST,
  path: '/flight',
  layout: PrivateLayout,
  component: FlightRequestList,
  permission: AccessType.FLIGHT_REQUEST_READ,
  childRoutes: [
    {
      path: '/flight/:id/assessment',
      component: FlightRequestAssessment,
      permission: AccessType.FLIGHT_REQUEST_RISK_ASSESSMENT,
    },
    {
      path: '/flight/:type/:id/edit',
      component: FlightRequestEdit,
      permission: AccessType.FLIGHT_REQUEST_UPDATE,
    },
    {
      path: '/flight/:type/:id/duplicate',
      component: FlightRequestDuplicate,
    },
    {
      path: '/flight/request',
      component: FlightRequestAdd,
      permission: AccessType.FLIGHT_REQUEST_CREATE,
      exact: true,
    },
  ],
};

const FireFightingDispatchRoute: IRoute = {
  label: Lang.TTL_FIRE_DISPATCH_DISPATCH,
  path: '/dispatch',
  layout: PrivateLayout,
  component: FlightDispatchList,
  permission: AccessType.FIRE_DISPATCH_READ,
  childRoutes: [
    {
      path: '/dispatch/new',
      component: FireDispatchAdd,
    },
    {
      path: '/dispatch/:dispatchId/edit',
      component: FireDispatchEdit,
    },
  ],
};

const AdminRoute: IRoute = {
  label: Lang.TTL_ADMIN,
  path: '/admin',
  layout: PrivateLayout,
  component: AdminMenu,
  permission: AccessType.ADMIN_READ,
};

const NotificationRoute: IRoute = {
  label: Lang.TTL_NOTIFICATIONS,
  path: '/notifications',
  layout: PrivateLayout,
  component: Notification,
  permission: AccessType.NOTIFICATION_READ,
};

export const routes = [
  FlightsCalendarRoute,
  Main,
  FlightRequest,
  FireFightingDispatchRoute,
  AdminRoute,
  NotificationRoute,
];
export type IRouter = typeof routes[number];

export default routerFactory(routes, {
  Error404,
  Error403,
});
